var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70494 26.4995H26.2949C28.6049 26.4995 30.0449 23.9945 28.8899 21.9995L17.5949 2.48453C16.4399 0.489531 13.5599 0.489531 12.4049 2.48453L1.10994 21.9995C-0.0450623 23.9945 1.39494 26.4995 3.70494 26.4995ZM14.9999 15.9995C14.1749 15.9995 13.4999 15.3245 13.4999 14.4995V11.4995C13.4999 10.6745 14.1749 9.99953 14.9999 9.99953C15.8249 9.99953 16.4999 10.6745 16.4999 11.4995V14.4995C16.4999 15.3245 15.8249 15.9995 14.9999 15.9995ZM16.4999 21.9995H13.4999V18.9995H16.4999V21.9995Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c1494ee359cc6ce50e09735c2df24555.svg";
export { ForwardRef as ReactComponent };